// extracted by mini-css-extract-plugin
export var pillWrapper = "_qe-0";
export var showOverflow = "_qe-1";